import * as React from 'react';
import {TransData} from "@/common/dto/TransData";
import {InputWrap} from "@/component/input/InputWrap";
import {DateInput} from "@/component/input/DateInput";
import {AmountInput} from "@/component/input/AmountInput";
import {AccountInput} from "@/component/input/AccountInput";
import {StringInput} from "@/component/input/StringInput";
import {FtButton} from "@/common/FtButton";
import {BillingAccountType} from "@/common/dto/TransAccount";
import {useState} from "react";

interface Props {
    data: Partial<TransData>;
    setData: (data: Partial<TransData>) => void;
    hideLabel?: boolean;
}

export function TransactionForm(props: Props) {
    const {data, setData, hideLabel} = props;
    const [initialOutAccountType, setInitialOutAccountType] = useState<BillingAccountType | undefined>(data.outAccountId ? undefined : "CARD");
    const [initialInAccountType, setInitialInAccountType] = useState<BillingAccountType | undefined>(data.inAccountId ? undefined : "EXP");

    function setTypes(outType: BillingAccountType, inType: BillingAccountType) {
        setInitialInAccountType(inType);
        setInitialOutAccountType(outType);
    }

    return <div style={{display: "flex", flexDirection: "column"}}>

        <InputWrap label="거래일" hideLabel={hideLabel}>
            <DateInput
                value={data.transactDate}
                showNavButtons={true}
                required={false}
                onChange={(value) => setData({...data, transactDate: value})}
            />
        </InputWrap>

        <InputWrap label="금액" hideLabel={hideLabel}>
            <AmountInput
                value={data.amount ?? 0}
                onChange={(value) => setData({...data, amount: value})}
            />
        </InputWrap>

        <div style={{display: "flex", gap: 4, marginBottom: 8}}>
            <FtButton type="button" variant="outlined" onClick={() => setTypes('INC', 'BANK')}>수입</FtButton>
            <FtButton type="button" variant="outlined" onClick={() => setTypes('BANK', 'CARD')}>카드 결제</FtButton>
            <FtButton type="button" variant="outlined" onClick={() => setTypes('BANK', 'SAVE')}>저축</FtButton>
            <FtButton type="button" variant="outlined" onClick={() => setTypes('SAVE', 'BANK')}>해지</FtButton>
            <FtButton type="button" variant="outlined" onClick={() => setTypes('BANK', 'BANK')}>이체</FtButton>
        </div>

        <InputWrap label="출금 계정" hideLabel={hideLabel}>
            <AccountInput
                initialType={initialOutAccountType}
                value={data.outAccountId}
                onChange={(value) => {
                    setData({...data, outAccountId: value});
                    setInitialOutAccountType(undefined);
                }}
            />
        </InputWrap>

        <InputWrap label="입금 계정" hideLabel={hideLabel}>
            <AccountInput
                initialType={initialInAccountType}
                value={data.inAccountId}
                onChange={(value) => {
                    setData({...data, inAccountId: value});
                    setInitialInAccountType(undefined);
                }}
            />
        </InputWrap>

        <InputWrap label="적요" hideLabel={hideLabel}>
            <StringInput
                value={data.detail ?? ""}
                onChange={(v) => setData({...data, detail: v})}
                fullWidth
            />
        </InputWrap>
    </div>;
}